var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperPlaneTilt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9835 2.51642C13.8577 2.39079 13.7008 2.30092 13.5288 2.25604C13.3568 2.21117 13.176 2.21292 13.0049 2.26111L1.3594 5.54572C1.16346 5.60098 0.989054 5.71473 0.859493 5.87177C0.729932 6.02881 0.651389 6.22165 0.634363 6.42452C0.617337 6.62739 0.662639 6.83063 0.764213 7.00706C0.865788 7.1835 1.0188 7.32473 1.20279 7.41187L6.07363 9.71912L9.40377 6.38898C9.49755 6.29521 9.62473 6.24253 9.75735 6.24253C9.88997 6.24253 10.0172 6.29521 10.1109 6.38898C10.2047 6.48276 10.2574 6.60994 10.2574 6.74256C10.2574 6.87518 10.2047 7.00236 10.1109 7.09614L6.78079 10.4263L9.08804 15.2971C9.16796 15.4685 9.29525 15.6134 9.45488 15.7148C9.61452 15.8161 9.79982 15.8697 9.98892 15.8691C10.0175 15.8691 10.0464 15.8679 10.0754 15.8655C10.2786 15.8496 10.472 15.7715 10.6293 15.6418C10.7865 15.512 10.9 15.337 10.9542 15.1405L14.2388 3.495C14.2869 3.32391 14.2887 3.14308 14.2438 2.9711C14.1989 2.79912 14.1091 2.64219 13.9835 2.51642Z",
    fill: "#0D814A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlaneTilt);
export default __webpack_public_path__ + "static/media/paper-plane-tilt.2e341abad6af826ad107cf2295913730.svg";
export { ForwardRef as ReactComponent };